/**
 * Slider
 */
$('.block-slider-gallery').each((i, el) => {
	const $block = $(el);
	const $sliderEl = $block.find('.gallery-slider');
	const { nextArrow, prevArrow } = Globals.sliders;
	const isMobileOnlySlider = $block.hasClass('has-slider-type-mobile');
	const $controls = $sliderEl.next('.js-slider-controls');
	const breakpoint = 768;
	let $galleryItems;
	let $slides;

	// Default config - slider for both desktop and mobile
	let config = {
		dots: true,
		nextArrow,
		prevArrow,
		fade: true,
		appendArrows: $controls,
		appendDots: $controls,
		responsive: [
			{
				breakpoint,
				settings: {
					fade: false
				}
			}
		]
	};

	// Mobile only config - slider only on mobile
	if (isMobileOnlySlider) {
		$galleryItems = $sliderEl.find('.gallery-item');
		$slides = $galleryItems.children();
		config = {
			mobileFirst: true,
			dots: true,
			nextArrow,
			prevArrow,
			appendArrows: $controls,
			appendDots: $controls,
			responsive: [
				{
					breakpoint,
					settings: 'unslick'
				}
			]
		}

		// Change markup to remove slide wrappers for mobile
		if (Globals.$window.width() <= breakpoint) {
			// Mobile
			$sliderEl.empty().append($slides);
		} else {
			// Desktop
			$sliderEl.empty().append($galleryItems);
		}
	}

	// Initialize
	const $slider = $sliderEl.slick(config);

	// Controls
	// const $controls = $sliderEl.next('.js-slider-controls');
	// $slider.slick('setOption', 'appendDots', $controls, true);
	// $slider.slick('setOption', 'appendArrows', $controls, true);

	// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
	if ($slider.find('.slick-track').length === 0) {
		$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
		$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
	}

});
